import { legacy_createStore as createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { thunk } from 'redux-thunk'
import { logsReducer } from './reducers/logsReducer'
import { usersReducer } from './reducers/usersReducer'
import { odooReducer } from './reducers/odooReducer'
import { chatbotReducer } from './reducers/chatbotReducer'
import { sesameReducer } from './reducers/sesameReducer'
import { documentsReducer } from './reducers/documentsReducer'

const intialState = {}
const appReducer = combineReducers({
    logs: logsReducer,
    users: usersReducer,
    chatbot: chatbotReducer,
    odoo: odooReducer,
    sesame: sesameReducer,
    documents: documentsReducer
})

const reducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    reducer,
    intialState,
    composeEnhancer(applyMiddleware(thunk))
)

export default store